<template>
  <div :class="['productPrice', {detailed}]">
    <div class="prices">
      <span v-if="from" class="prefix">{{ $t('PRICE_PREFIX_FROM') }}</span>
      <strong :class="['price', {discounted: hasDiscount}]"><EuroAmount :amount="price"/></strong>
      <span v-if="hasDiscount" class="instead">{{ formatPrice(insteadOf) }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import BasicComponent from '@/global/BasicComponent';
import EuroAmount from '@/components/EuroAmount.vue';

@Component({components: {EuroAmount}})
export default class ProductPrice extends BasicComponent {
  @Prop({type: Number, default: 0}) readonly price!: number;
  @Prop({type: Number, default: 0}) readonly insteadOf!: number;
  @Prop({type: Boolean, default: false}) readonly from!: boolean;
  @Prop({type: Boolean, default: false}) readonly detailed!: boolean;

  get hasDiscount(): boolean {
    return this.insteadOf > 0 && this.price / this.insteadOf - 1 <= -0.01;
  }
}
</script>

<style scoped lang="scss">
@import '../stylesheets/Variables.scss';

.productPrice {
  min-width: 0;

  .prices {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px 8px;
  }

  .prefix, .instead {
    color: $shop-price-label;
    font-size: 14px;
    font-weight: 400;
  }

  .prefix {
    font-size: 11.2px;
    align-self: flex-end;
    line-height: 1;
    // Halve only the gap before the price, retaining the old-price spacing.
    margin-right: -4px;
  }

  .price {
    color: $price-color;
    font-size: 28px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;

    &.discounted {

      color: $price-color-discount;

    }
  }

  .instead {
    text-decoration: line-through;
    white-space: nowrap;
  }

  &:not(.detailed) {
    .prices {
      align-items: center;
    }
    .price {
      display: flex;
    }
  }

  &.detailed {
    text-align: right;

    .prices {

      justify-content: flex-end;

      gap: 6px 10px;

    }
    .prefix {
      margin-right: -5px;
    }
    .price {
      font-size: 36px;
    }
    .instead {
      font-size: 18px;
    }
  }
}
</style>
